export const LogoMark = ({ className = "h-8 w-8", color = "#A9503A" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <defs>
      <mask id="lun-crescent">
        <rect width="32" height="32" fill="white" />
        <circle cx="20.5" cy="12.5" r="10" fill="black" />
      </mask>
    </defs>
    <circle cx="16" cy="16" r="13" fill={color} mask="url(#lun-crescent)" />
    <path d="M21 14.5c2.2 2.6 3.2 4.4 3.2 5.8a3.2 3.2 0 0 1-6.4 0c0-1.4 1-3.2 3.2-5.8z" fill={color} />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark color={light ? "#F4DED3" : "#A9503A"} />
    <span className={`font-serif text-2xl tracking-tight ${light ? "text-[#FBF5EE]" : "text-[#2C221E]"}`}>
      Lunelle
    </span>
  </span>
);
